import React from 'react';
import styled from 'styled-components';
import { SvgIcon } from '../Icon';
import { theme } from '../../styles/theme';

interface IProps {
  hint: string;
  className?: string;
}

const Container = styled.div`
  display: flex;
  column-gap: 12px;
  color: ${theme.colors.mainBlue};
`;

const HintIcon = styled(SvgIcon)`
  flex: 0 0 auto;
  margin-top: 2px;
`;

const HintText = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
`;

export default ({ hint, className }: IProps) => (
  <Container className={className}>
    <HintIcon name="triangle-exclamation" width={19} height={16} isActive />
    <HintText>{hint}</HintText>
  </Container>
);
